import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';
const ClockIcon = React.memo(
  ({
    fill = variables['colors-mc-primary'],
    fillOpacity = '0.5',
    width = 30,
    viewBox = '0 0 30 30'
  }) => (
    <svg
      className={'mc-pointer'}
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <g id='alarm_1_' data-name='alarm (1)' opacity={fillOpacity}>
        <path
          id='Path_11186'
          data-name='Path 11186'
          d='M10.688,5.937a.937.937,0,1,0-1.875,0v6.3L6.133,16.7a.938.938,0,1,0,1.609.966l2.812-4.687a.937.937,0,0,0,.133-.482Z'
          transform='translate(5.249 4.375)'
          fill={fill}
        />
        <path
          id='Path_11187'
          data-name='Path 11187'
          d='M12.187,0a.937.937,0,1,0,0,1.875h.937V3.881A13.127,13.127,0,0,0,6.988,27.27L5.859,28.4a.938.938,0,1,0,1.326,1.327l1.4-1.4a13.143,13.143,0,0,0,12.832,0l1.4,1.4A.938.938,0,0,0,24.14,28.4L23.013,27.27A13.127,13.127,0,0,0,16.875,3.881V1.875h.937a.937.937,0,1,0,0-1.875Zm1.946,5.659a11.424,11.424,0,0,1,1.732,0,11.25,11.25,0,1,1-1.732,0ZM0,6.562A4.676,4.676,0,0,0,1.612,10.1,15.065,15.065,0,0,1,8.226,3.487,4.687,4.687,0,0,0,0,6.562ZM25.312,1.875a4.676,4.676,0,0,0-3.538,1.612A15.065,15.065,0,0,1,28.387,10.1a4.687,4.687,0,0,0-3.075-8.226Z'
          fill={fill}
        />
      </g>
    </svg>
  )
);
ClockIcon.displayName = 'ClockIcon';

export default ClockIcon;
